import { getPosition } from '../utils';

export default class ModRacing {
  constructor(el) {
    this.$el = $(el);
    this.scrollTopWindow = 0;
    this.positionFlag = 0;
    this.offsetTopModule = getPosition(this.$el.get(0)).y;
    this.heightWindow = $(window).innerHeight();
    this.heightModule = this.$el.innerHeight();

    this.init();
  }

  init() {
    this.addListeners();
  }

  addListeners() {
    window.scrollAgent.scrollEvent((args) => {
      this.scrollTopWindow = parseFloat(args.scroll.y.toFixed(2));
      if (this.positionFlag !== this.scrollTopWindow) {
        this.positionFlag = this.scrollTopWindow;
        this.offsetTopModule = getPosition(this.$el.get(0)).y;
        this.heightWindow = $(window).innerHeight();
        this.heightModule = this.$el.innerHeight();

        this.eventScrollStartOrPauseAnimation();
      }
    });
  }

  eventScrollStartOrPauseAnimation() {
    const scrollBottomWindow = this.scrollTopWindow + this.heightWindow;
    if (scrollBottomWindow > this.offsetTopModule + (this.heightModule * 0.70)) {
      this.$el.addClass('final-scroll');
    } else {
      this.$el.removeClass('final-scroll');
    }
  }
}
